import styled from 'styled-components';
import Button, { ButtonProps } from 'antd/lib/button';

// internal
import { flex } from '@app/assets/styles/mixins';
import * as forms from '@app/assets/styles/forms';

interface IContainerProps extends ButtonProps {
  hideShadow?: boolean;
  fontSize?: string;
  iconSize?: string;
  width?: string;
  height?: string;
  grayColor?: boolean;
  $iconOnly?: boolean;
  borderNone?: boolean;
  danger?: boolean;
}

// color: ${(props) => (props.grayColor ? props.theme.darkblue : '#fff')};

const Container = styled(Button)<IContainerProps>`
  ${(props) => forms.Input(props.borderNone as boolean)}
  border-radius: 8px;
  padding: 0px 11px;
  height: ${(props) => (props.height ? props.height : '33px')};
  width: ${(props) => (props.width ? props.width : 'auto')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1rem')};
  svg {
    margin-right: ${(props) => (props.$iconOnly ? '0' : '8px')};
    font-size: ${(props) => (props.iconSize ? props.iconSize : '20px')};
  }

  &.ant-btn-primary {
    background-color: ${(props) => (props.grayColor ? props.theme.ggBackground : '#1c2260')};
    border: 1px solid #1c2260;

    &:hover,
    &:active,
    &:focus {
      background-color: #272c3f;
      border: 1px solid #707070;
    }

    &:disabled {
      background-color: ${(props) => props.theme.ggBackground};
    }
  }

  &.ant-btn-default {
    background: #dbdbdb;
    color: #1c2260;

    &:hover,
    &:active,
    &:focus {
      background: #e3e3e3;
    }
  }

  .icon {
    padding-right: 5px;
  }

  .button-label {
    ${flex('center', 'center')}
  }
`;

export default Container;
